module.exports = require("@adobe/cq-spa-component-mapping");